var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"newsIcon",staticStyle:{"margin-right":"0.6rem"}},[_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:({
      trigger: 'hover',
      title: _vm.$g('messages'),
      boundary: 'window',
      container: 'news_1'
    }),expression:"{\n      trigger: 'hover',\n      title: $g('messages'),\n      boundary: 'window',\n      container: 'news_1'\n    }"}],attrs:{"id":"news_1"},on:{"click":_vm.toNotification}},[_c('b-icon',{attrs:{"icon":"bell","font-scale":"1.5"}}),_c('span',{staticClass:"newsIcon_msg"},[_vm._v(_vm._s(_vm.getMessageCount))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }